(function(){
const $=id=>document.getElementById(id);
const eur=c=>(c/100).toFixed(2).replace(".",",")+" €";
const drawer=$("cartDrawer"), ov=$("cartOverlay"), list=$("cartList"), tot=$("cartTotal"), badge=$("cartCount"), btn=$("cartOpen");
let cart=null;
function setBadge(n,bump){
  badge.textContent=n; badge.hidden=n===0;
  if(bump){btn.classList.remove("bump");void btn.offsetWidth;btn.classList.add("bump");}
}
function render(){
  const items=cart.items||[];
  setBadge(items.reduce((a,it)=>a+it.quantity,0));
  if(!items.length){
    list.innerHTML=`<div class="cd-empty"><i class="umb"></i><b>Tu carrito está vacío</b><span>Añade el secador y te llega en 24–72 h.</span></div>`;
    tot.textContent=eur(0); $("cartCheckout").hidden=true; return;
  }
  $("cartCheckout").hidden=false;
  list.innerHTML=items.map((it,i)=>`<div class="cd-item">
      <img src="${it.image?it.image+(it.image.includes("?")?"&":"?")+"width=160":""}" alt="">
      <div class="cd-info"><b>${it.product_title}</b><span>${eur(it.final_price)} / unidad</span>
        <div class="cd-qty"><button type="button" data-l="${i+1}" data-q="${it.quantity-1}" aria-label="Quitar uno">−</button><span>${it.quantity}</span><button type="button" data-l="${i+1}" data-q="${it.quantity+1}" aria-label="Añadir uno">+</button></div>
      </div>
      <div class="cd-price">${eur(it.final_line_price)}<button type="button" class="cd-rm" data-l="${i+1}" data-q="0">Eliminar</button></div>
    </div>`).join("");
  tot.textContent=eur(cart.total_price);
}
async function load(){ const r=await fetch("/cart.js",{headers:{Accept:"application/json"}}); cart=await r.json(); render(); }
async function change(line,qty){
  const r=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({line,quantity:qty})});
  cart=await r.json(); render();
}
function open(){ drawer.hidden=false; ov.hidden=false; requestAnimationFrame(()=>{drawer.classList.add("on");ov.classList.add("on");}); document.body.style.overflow="hidden"; $("cartClose").focus(); }
function close(){ drawer.classList.remove("on"); ov.classList.remove("on"); document.body.style.overflow=""; setTimeout(()=>{drawer.hidden=true;ov.hidden=true;},250); btn.focus(); }
btn.addEventListener("click",()=>{open(); if(!cart) load();});
$("cartClose").onclick=close; ov.onclick=close; $("cartKeep").onclick=close;
document.addEventListener("keydown",e=>{if(e.key==="Escape"&&!drawer.hidden)close();});
list.addEventListener("click",e=>{const b=e.target.closest("[data-l]");if(b) change(+b.dataset.l,+b.dataset.q);});
window.PlicCart={
  async add(items){
    const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items})});
    if(!r.ok) throw new Error((await r.json()).description||"Error");
    await load(); setBadge(+badge.textContent,true); open();
  }
};
load().catch(()=>{});
})();
